import cache from 'memory-cache';

export default async function remember<T>(
  key: string,
  seconds = 60,
  getter: () => Promise<T>
): Promise<T> {
  let value = cache.get(key);
  if (!value) {
    value = await getter();
    cache.put(key, value, seconds * 1000);
  }
  return value;
}
